import type { FaireProductEntity } from "../../entity_types/product";

export const p_skta3sqaky: FaireProductEntity = {
  token: "p_skta3sqaky",
  type: "product",
  name: "Vintage Stainless Steel Inlaid Natural Stone Rings - FGS/CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/db0a44f59e5de9c5023efad9b7ce4b2f8e237e359e786a198a0fa8def13c1971.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e08a950c46c7576aff0c40625d2629f569df63a69be7b10f2c5f290be3506c79.jpeg",
    "https://cdn.faire.com/fastly/16c8575c9a0995f4b67beb0fb94574197a1ee4a72b6bfb09d37595be2d2a1b4a.jpeg",
    "https://cdn.faire.com/fastly/0d1e484c1ecc28f1dc7c915525aafd3a94d2b9d4666e6661d61058e73dfe4bd7.jpeg",
    "https://cdn.faire.com/fastly/4dde985a096968b8b969dd0812a28a49eebbe1d277e69351f35de3db68da281e.jpeg",
    "https://cdn.faire.com/fastly/f3c6bbc72fca2a2b4265119fcfe8589f6270029a7bc6f438c22fb224ebe48be5.jpeg",
    "https://cdn.faire.com/fastly/e1de0814c0a8ec63b8f7349ba89e955784a0cb2de21762464973f30c0deda896.jpeg",
    "https://cdn.faire.com/fastly/798ba489a23bae2e66d180031f1546c5b5843cc0d02abb0dee34b38425ea0935.jpeg",
  ],
  priceDollars: 7.38,
  description:
    "\nCategory: Ring \n\nMaterial: Stainless steel, gold-plated, natural stone \n\nSize: Adjustable opening \n\nProcess: Vacuum electroplating and manual polishing\n\n\nSurface : High Polish\n\n★Made of high quality stainless steel, Lead-free, Harmless to Human Body.\n\n★Perfect jewelry gift\n",
  tags: [],
  msrpDollars: 14.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:30.057Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
